export default [
    {
        code: 1,
        colorCode: 'black',
    },
    {
        code: 2,
        colorCode: 'white',
    },
    {
        code: 3,
        colorCode: 'grey',
    },
    {
        code: 4,
        colorCode: 'blue',
    },
    {
        code: 5,
        colorCode: 'red',
    },
    {
        code: 6,
        colorCode: 'yellow',
    },
    {
        code: 7,
        colorCode: 'green',
    },
    {
        code: 8,
        colorCode: 'orange',
    },
    {
        code: 9,
        colorCode: 'beige',
    },
    {
        code: 10,
        colorCode: 'brown',
    },
    {
        code: 11,
        colorCode: 'silver',
    },
    {
        code: 12,
        colorCode: 'gold',
    },
    {
        code: 13,
        colorCode: 'purple',
    },
    {
        code: 14,
        colorCode: 'charcoal',
    },
    {
        code: 15,
        colorCode: '#CD7F32',
    },
    {
        code: 16,
        colorCode: 'burgandy',
    },
    {
        code: 17,
        colorCode: 'tin',
    },
    {
        code: 18,
        colorCode: 'tan',
    },
    {
        code: 19,
        colorCode: 'taupe',
    },
    {
        code: 20,
        colorCode: 'cream',
    },
    {
        code: 21,
        colorCode: 'ligthblue',
    },
    {
        code: 22,
        colorCode: 'darkblue',
    },
    {
        code: 23,
        colorCode: 'darkgreen',
    },
    {
        code: 24,
        colorCode: 'ligthgreen',
    },
    {
        code: 25,
        colorCode: 'darkgrey',
    },
];
